import { SET_SIDEBAR_POSITION, SIDEBAR_ERROR } from './types';

export const setSidebarPosition = (role, position) => dispatch => {
    dispatch({
        type: SET_SIDEBAR_POSITION,
        payload: position
    });

};